import React, { useEffect, useState } from 'react'
import BaseCreatePage from '../../../../components/hooks/BaseCreatePage'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  clearEditingUser,
  edit,
  fetchPermissionStructure,
  fetchUsers,
  post,
  update,
} from '../../UserActions'
import {
  Box,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import colors from '../../../../assets/colors'
import Form from './Form'
import Tabs from '../../../../components/hooks/BaseTabs/Tabs'
import Tab from '../../../../components/hooks/BaseTabs/Tab'
import {
  mdiAccountChild,
  mdiAccountDetails,
  mdiCurrencyUsd,
  mdiCurrencyUsdOff,
} from '@mdi/js'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../../components/hooks/BaseTableComponents'
import { CustomCheckbox } from '../../../../components/ui/custom-checkbox'
import { usePermissions } from '../../../../hooks/usePermission'
import { RoleAccesss } from './RoleAccess'

const useStyles = makeStyles({
  rowMessage: {
    padding: '8px 0',
    borderTop: '1px dashed',
    borderColor: colors.textSecondary,
    borderBottom: '1px dashed',
    borderBottomColor: colors.textSecondary,
    color: colors.textPrimary,
    fontSize: '14px',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    height: 'auto',
    fontWeight: 'normal',
  },
})

export const CreateEditUser = props => {
  const history = useHistory()
  const dispatch = useDispatch()
  const styles = useStyles()

  const user = useSelector(state => state.user.editingUser)

  const { see, id } = props.match.params

  const [value, setValue] = useState(0)

  const handleClose = () => {
    history.goBack()
  }

  useEffect(() => {
    dispatch(fetchUsers('rows=1&page=1'))

    // Sem id na rota é cadastro: o editingUser de uma edição anterior ainda
    // está no store e preencheria o formulário (inclusive o id).
    if (!id) {
      dispatch(clearEditingUser())
      return undefined
    }

    dispatch(edit(id))
    dispatch(fetchPermissionStructure())

    return () => dispatch(clearEditingUser())
  }, [])

  const submitWhenCreate = async form => {
    const resp = await dispatch(post(form))
    if (resp?.code == 200) return handleClose()
  }

  const submitWhenEdit = async form => {
    const resp = await dispatch(update(form))
    if (resp?.code == 200) return handleClose()
  }

  const handleSubmit = async form => {
    if (id) return submitWhenEdit(form)
    return submitWhenCreate(form)
  }

  const handleChangeTab = tab => {
    setValue(tab)
  }

  return (
    <BaseCreatePage
      page="Usuários"
      path={id ? 'Editar' : 'Cadastrar'}
      onClose={handleClose}
      goBack
      hiddenReturn
    >
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container className={styles.rowMessage}>
              <Grid item xs={12}>
                <Box item xs={12} className={styles.message}>
                  Utilize os campos abaixo para{' '}
                  {id ? 'editar um' : 'cadastrar um novo'} usuário
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Tabs>
              <Tab
                label="Dados Básicos"
                value={value}
                setValue={handleChangeTab}
                tabIndex={0}
                iconColor={colors.primary}
                removeNavigation={false}
                icon={mdiAccountDetails}
              />
              <Tab
                label="Permissões"
                value={value}
                setValue={handleChangeTab}
                tabIndex={1}
                iconColor={colors.info}
                removeNavigation={false}
                icon={mdiAccountChild}
              />
            </Tabs>
          </Grid>

          <Grid item xs={12} hidden={value == 1}>
            <Form
              btnText="Salvar"
              onSubmit={handleSubmit}
              onClose={handleClose}
              data={user || {}}
              see={see}
            />
          </Grid>

          <Grid item xs={12} hidden={value == 0}>
            <RoleAccesss />
          </Grid>
        </Grid>
      </Grid>
    </BaseCreatePage>
  )
}
